/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import {
    Form,
    InputGroup,
    Image,
    Button,
    Col,
    Card,
    Row,
} from 'react-bootstrap';
import { PencilIcon, TrashIcon } from '@heroicons/react/solid';
import * as S from '../../../../../../styles';
import { ITweetyWidgetProps } from '@/widgets/tweety-widget-react-main/';
import * as LS from '../../../../../FileDropZone/styles';
import { AiFillCloseCircle } from 'react-icons/ai';

export interface IKanbanCardProps {
    onDelete?(): void;
    onEdit?(): void;
    cardRef: any;
    title: string;
    initialData?: any;
    cardType?: string;
    titleColor?: string;
    attributeType: string;
    isRequired?: string;
    attributeOptions?: string;
    image?: string;
    style?: any;
    hiddenFields?: string[];
    attributeForm?: ITweetyWidgetProps;
    extraProps?: any;
    id?: string;
    labelColor?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
}

export const KanbanCard = (props: IKanbanCardProps) => {
    const {
        cardRef,
        title,
        titleColor,
        onEdit,
        attributeType,
        initialData,
        attributeOptions,
        isRequired,
        attributeForm,
        image,
        labelColor,
        value,
        placeholder,
        cardType,
        onDelete,
        fontScale,
        onCompChange,
        style = {},
        extraProps = {},
        id,
        hiddenFields,
    } = props;
    const [textValue, setTextValue] = useState(value ?? '');
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };

    const _renderLabelIf = () => {
        if (title) {
            return (
                <S.FormLabel
                    fontScale={fontScale}
                    style={{ paddingLeft: '0px' }}
                    color={titleColor}
                >
                    {title}
                    {isRequired && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const DropzoneFile = (props: any) => {
        const { name, base64, fileIndex } = props;
        const imageSrc = props?.type?.includes('image')
            ? base64
            : 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/certificate_grey.png';

        console.log('imageis:', imageSrc);
        return (
            <>
                <Col
                    xs={5}
                    sm={5}
                    md={4}
                    lg={2}
                    key={name}
                    className="dropzone-preview mt-2 ms-2 me-2"
                >
                    <div style={LS.DropZoneFileContainer}>
                        <Image
                            src={imageSrc}
                            className="dropzone-image "
                            resizeMode={'contain'}
                            thumbnail
                            width={'100px'}
                            height={'100px'}
                        />
                        {/* <AiFillCloseCircle
                                size={22}
                                onClick={removeSelection.bind(null, fileIndex)}
                                style={LS.DropZoneFileRemoveIcon}
                            /> */}
                    </div>
                    <Card.Text className="dropzone-filename">{name}</Card.Text>
                </Col>
            </>
        );
    };

    const _renderForm = () => {
        console.log('ho->', attributeForm);
        const actualFields = attributeForm?.fields?.filter(
            (item) =>
                (!hiddenFields ||
                    hiddenFields?.filter(
                        (_item) => _item === item?.compProps?.id
                    )?.length === 0) &&
                initialData[item?.compProps?.id]
        );
        const tableFields = actualFields?.map((item) => {
            if (typeof initialData[item?.compProps?.id] === 'string') {
                return { ...item, val: initialData[item?.compProps?.id] };
            }
            if (initialData[item?.compProps?.id]?.val) {
                return { ...item, val: initialData[item?.compProps?.id]?.val };
            }
            return null;
        });
        console.log('mn->', tableFields, actualFields);
        const fileUploads = actualFields?.filter(
            (item) =>
                Array.isArray(initialData[item?.compProps?.id]) &&
                initialData[item?.compProps?.id]?.length > 0
        );
        console.log('lmno->', tableFields);
        return (
            <>
                <table
                    className="d-flex flex-column flex-grow-1"
                    style={{
                        fontSize:
                            fontScale !== undefined
                                ? `${16 + props?.fontScale * 1.5}px`
                                : '16px',
                    }}
                >
                    <tbody>
                        {tableFields
                            ?.filter((item) => item)
                            ?.map((item) => {
                                return (
                                    <tr className="d-flex align-items-center mx-2">
                                        <th
                                            className="fw-bold"
                                            style={{ color: labelColor }}
                                        >
                                            {item?.compProps?.label}{' '}
                                        </th>

                                        <td className="">
                                            {': '}
                                            {item?.val}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
                {/* <Row className="dropzone-files">
                    {' '}
                    {fileUploads?.map((item) => {
                        const file = initialData[item?.compProps?.id]?.[0];
                        return (
                            <DropzoneFile
                                key={file.name}
                                base64={file.base64 ?? file.src}
                                // base64={file.src}
                                {...file}
                            />
                        );
                    })}
                </Row> */}
            </>
        );
    };

    return (
        <div
            ref={cardRef}
            className=""
            style={{ width: '100%', paddingLeft: '15px' }}
        >
            <Form.Group id={id} className="">
                {_renderLabelIf()}
                <InputGroup className="d-flex justify-content-end">
                    {/* <S.FormControl fontScale={fontScale}
                        // className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={isRequired}
                        type="text"
                        placeholder={placeholder}
                    /> */}
                    <Button variant="outline-secondary" onClick={onEdit}>
                        <PencilIcon className="icon icon-xs text-black me-2" />
                    </Button>
                    <Button variant="outline-secondary" onClick={onDelete}>
                        <TrashIcon className="icon icon-xs text-black me-2" />
                    </Button>
                </InputGroup>
            </Form.Group>
            {_renderForm()}
        </div>
    );
};

KanbanCard.defaultProps = {
    required: false,
};
